<template>
  <DataTable default-to-primera :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable">
    <span slot="after-filters">
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="downloadExcel" flat>
          <v-icon color="primary">far fa-file-excel</v-icon>
        </v-btn>
        <span>Descargar XLS</span>
      </v-tooltip>
    </span>
  </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTable
  },

  props: {
    path: {
      type: String,
      default: 'adendas/jugadores/list'
    },
    filterPath: {
      type: String,
      default: 'filters/adendas'
    },
    excelPath: {
      type: String,
      default: 'adendas/jugadores/xls'
    },
    filenamePrefix: {
      type: String,
      default: 'adendas_jugadores'
    }
  },

  data () {
    return {
      headers: [
        { text: 'Desde Presentación', value: 'fromDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Hasta Presentación', value: 'toDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Club', value: 'club', sortable: true, filterField: true, align: 'left' },
        { text: 'Apellido', value: 'playerLastName', sortable: false, align: 'left' },
        { text: 'Nombre', value: 'playerFirstName', sortable: false, align: 'left' },
        { text: 'Contrato', value: 'Contrato', sortable: false, align: 'left' },
        { text: 'Fecha de presentación', value: 'fechaPresentacion', align: 'left' }
      ],
      properties: ['club', 'playerLastName', 'playerFirstName', 'contrato', 'fechaPresentacion'],
      sendEmailAlert: false
    }
  },

  methods: {
    noContracts (item) {
      return (item.verified + item.pending + item.rejected + item.ended) === 0
    },
    getExcelPath () {
      return this.excelPath + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return this.filenamePrefix
    }
  }
}

</script>

<style scoped>
    .table-row {
        background-color: white;
        border-bottom: 1px solid #959ba6;
    }
    .table-row-no-contracts {
        background-color: #d0caca;
        border-bottom: 1px solid #959ba6;
    }
</style>
